import Loader from 'Components/Common/Loader'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchCompeitionGroupThunk, fetchSharedCompeitionGroupThunk } from 'slices/competitionAnalysis/thunk'
import { setHeaderCompetitionGroup } from 'slices/ui/reducer'
import { AppDispatch, RootState } from 'store'
import "./style.scss";
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap'
import userDummyImg from "../../assets/images/users/user-dummy-img.jpg"
import SocialAccountCreators from 'Components/social-account/SocialAccountCreators'
import SocialAccountCreatorsFilters from 'Components/social-account/SocialAccountCreators/Filters'
import SocialAccountContentFilters from 'Components/social-account/SocialAccountContent/Filters'
import SocialAccountContent from 'Components/social-account/SocialAccountContent'
import CompetitionGroupDashboard from 'Components/CompetitionAnalysis/CompetitionGroup/Dashboard'

const CompetitionGroupPublic = () => {
    const { competitionGroupShareId } = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const shared = useSelector((state: RootState) => state.competitionAnalysis.shared_group)

    const competitionGroup = useSelector((state: RootState) => state.competitionAnalysis.shared_group[competitionGroupShareId!]?.data);
    const tiers = useSelector((state: RootState) => state.competitionAnalysis.shared_group[competitionGroupShareId!]?.creator_follower_tiers);
    
    const loading = useSelector((state: RootState) => state.competitionAnalysis.loading);
    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        if (competitionGroupShareId) {
            setInitialLoading(true);
            dispatch(fetchSharedCompeitionGroupThunk({ competitionGroupShareId })).finally(() => setInitialLoading(false));
        }
    }, [competitionGroupShareId])

    if (initialLoading) return <Loader />

    return (
        <div className="campaign-page pt-4">
            <div className="campaign-page-content">
                {competitionGroup &&
                    <CompetitionGroupDashboard competitionGroup={competitionGroup} tiers={tiers} isPublicPage={true} />
                }
            </div>
        </div>

    )
}

export default CompetitionGroupPublic
